import { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import ShopDrawer from "../ShopDrawer";

/** `/shop` route: the same shop drawer the header opens; closing it leaves the page. */
export default function ShopButton() {
  const navigate = useNavigate();
  const location = useLocation();
  const [open, setOpen] = useState(true);

  function close() {
    setOpen(false);
    // "default" = first entry of this app session (direct visit / external link), so there is nothing in-app to go back to.
    if (location.key !== "default") navigate(-1);
    else navigate("/", { replace: true });
  }

  return <ShopDrawer isOpen={open} onClose={close} />;
}
